import { render } from "./Docking.vue?vue&type=template&id=4b3245ea&scoped=true"
import script from "./Docking.vue?vue&type=script&lang=js"
export * from "./Docking.vue?vue&type=script&lang=js"

import "./Docking.vue?vue&type=style&index=0&id=4b3245ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b3245ea"

export default script